import api from './axios';

export const profileAPI = {
  // API #6 — GET /api/profile
  getProfile: () => api.get('/profile'),

  // API #7 — POST /api/profile/photo
  uploadPhoto: (data) => api.post('/profile/photo', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),

  // API #8 — PUT /api/profile/details
  updateDetails: (data) => api.put('/profile/details', data),

  // API #9 — POST /api/profile/id-proof
  uploadIdProof: (data) => api.post('/profile/id-proof', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),

  // API #10 — POST /api/profile/bank-account
  storeBankAccount: (data) => api.post('/profile/bank-account', data),

  // API #11 — PUT /api/profile/bank-account
  updateBankAccount: (data) => api.put('/profile/bank-account', data),

  // API #12 — POST /api/profile/nominee
  storeNominee: (data) => api.post('/profile/nominee', data),

  // API #13 — PUT /api/profile/nominee
  updateNominee: (data) => api.put('/profile/nominee', data),
};
